import { Stack, Title } from '@mantine/core';
import moment from 'moment';

import { EnvironmentCountries, EORIGIN_DATE_FORMAT_WITH_TIME, InControl } from '@e-origin/shared';

import { Table, TableColumnProps } from '@components';
import { useSettings } from '@hooks/useSettings';

interface ControlRequestedDocumentsProps {
  requestedDocuments: InControl['requestedDocuments'];
}

export const ControlRequestedDocuments = ({ requestedDocuments }: ControlRequestedDocumentsProps) => {
  const { data: settings } = useSettings();

  if (!requestedDocuments?.length) {
    return null;
  }

  const columns: TableColumnProps<(typeof requestedDocuments)[number]>[] = [
    {
      name: 'Type',
      cell: (row) => row.type,
    },
    {
      name: 'Reference number',
      cell: (row) => row.referenceNumber,
    },
    {
      name: 'Description',
      cell: (row) => row.description,
    },
    {
      name: 'CC Qualifier',
      cell: (row) => row.ccQualifier,
      hide: settings.country === EnvironmentCountries.NL,
    },
    {
      name: 'Request date',
      cell: (row) => (row.requestDate ? moment(row.requestDate).format(EORIGIN_DATE_FORMAT_WITH_TIME) : ''),
    },
    {
      name: 'Status',
      cell: (row) => {
        if (row.pendingResponse) return 'Pending';
        if (row.docsAvailable) return 'Response sent';
        if (row.docsAvailable === false) return 'Notified customs docs not available';

        return '';
      },
      hide: settings.country === EnvironmentCountries.BE,
    },
  ];

  return (
    <Stack mt={15} ml={20}>
      <Title size="md">Requested documents</Title>
      <Table dataSource={requestedDocuments} columns={columns} pagination={false} verticalSpacing="xs" />
    </Stack>
  );
};
